import { render, staticRenderFns } from "./dialog-register.vue?vue&type=template&id=2743cd03"
import script from "./dialog-register.vue?vue&type=script&lang=js"
export * from "./dialog-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports